<template>
  <v-card class="pa-4 blue-grey darken-3" elevation="0">
    <h3 class="text-center subtitle mb-3 grey--text">
      Preencha a assinatura abaixo
    </h3>
    <v-lazy>
      <VueSignaturePad
        id="signature"
        width="100%"
        height="80px"
        ref="signaturePad"
      />
    </v-lazy>

    <div class="mt-4" v-if="showValidator">
      <v-text-field
        :value="value"
        @input="updateValue"
        dark
        outlined
        dense
        placeholder="Nome"
      ></v-text-field>
    </div>

    <div class="d-flex justify-end mt-4">
      <v-btn class="primary-button ma-1" depressed @click="undo">
        Desfazer
      </v-btn>
      <v-btn class="secondary-button ma-1" depressed @click="save">
        Salvar
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'SignatureScreen',

  props: {
    showValidator: {
      type: Boolean,
      default: true,
    },
    value: String,
  },

  model: {
    prop: 'value',
    event: 'changeValue',
  },

  data: () => ({
    options: {
      penColor: '#c0f',
    },
  }),

  methods: {
    updateValue(event) {
      this.$emit('changeValue', event)
    },
    undo() {
      this.$refs.signaturePad.undoSignature()
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()

      if (isEmpty) {
        this.$toast.error('Preencha a assinatura para continuar')
      }

      this.$emit('save', data)
    },
    change() {
      this.options = {
        penColor: '#00f',
      }
    },
    resume() {
      this.options = {
        penColor: '#c0f',
      }
    },
  },
}
</script>

<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: '100%';
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
</style>
